Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-request-offer-box');

    if ($wrappers.length < 1) return;

    $wrappers.each(function (i, wrapper) {
        var $wrapper = $(wrapper);
        var $detailsWrapper = $('.x-request-offer-details-expandable', $wrapper);

        $('[data-click="expanded-request-offer"]', $wrapper).on('click', function (e) {
            var $expandBtn = $(this);

            if ($expandBtn.hasClass('expanded')) {
                $detailsWrapper.slideUp(200);
                $expandBtn.removeClass('expanded');
            } else {
                $detailsWrapper.slideDown(200);
                $expandBtn.addClass('expanded');
            }
        });
    });

});
